module.exports = __webpack_public_path__ + "img/logo.cf4962cf.png";